import { PlusOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { PageHeader } from "@/shared/components/PageHeader";
import { OrgTypeFormModal } from "../components/OrgTypeFormModal";
import { OrgTypeTable } from "../components/OrgTypeTable";
import { useOrgTypesStore } from "../store/org-types.store";

export function OrganizationTypesPage() {
	const onOpen = useOrgTypesStore((s) => s.onOpen);

	return (
		<div>
			<PageHeader
				title="Tashkilot turlari"
				action={
					<Button
						type="primary"
						icon={<PlusOutlined />}
						onClick={() => onOpen()}
						id="org-types-create-btn"
					>
						Qo&apos;shish
					</Button>
				}
			/>
			<OrgTypeTable />
			<OrgTypeFormModal />
		</div>
	);
}
